<template>
  <Head>
    <title>Food Production Report | NutriStudents K-12</title>
    <meta name="description" content="Food Production Report" />
  </Head>
  <default-layout>
    <BreadcrumLayout>
      <U>Tools</U>
    </BreadcrumLayout>
    <PageTitleLayout>
      <div class="lg:mb-0 mb-4 w-full">
        <h1 class="heading-color xl:text-4xl text-2xl font-bold">
          Food Production Report
        </h1>
      </div>
      <div class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center"></div>
    </PageTitleLayout>

    <div
      class="xl:flex w-full xl:px-10 px-5 xl:pt-10 pt-5 lg:mb-10 mb-5 justify-between items-end"
    >
      <div class="sm:flex flex-wrap items-end -mx-3">
        <div
          class="relative focus:outline-none lg:w-72 sm:w-1/2 w-full px-3 xl:mt-0 mb-4 lg:mb-0 ml-5"
        >
          <label for="" class="font-bold text-black-800 uppercase text-sm">Date</label>



          <div
            class="col-6 p-2 border col-md-auto m-auto flex justify-between cursor-pointer relative pr-12 bg-white rounded-lg overflow-hidden"
            @click="showCalendar()"
          >
            {{ selectedDate[0].format("DD MMM, YYYY") }} -
            {{ selectedDate[1].format("D MMM, YYYY") }}
            <i style="display: flex" class="fa fa-calendar absolute top-0 right-0 bg-[#39b54a] w-[40px] h-[40px] justify-center items-center text-white"></i>
          </div>
          <div class="row mt-1 border absolute left-0 bg-white z-10" v-show="show.calendar">
            <DatePicker
              :lastMonth="true"
              v-model="selectedDate"
              @onSelect="showCalendar"
              @onCancel="showCalendar"
              :next-prev-icon="true"
              :last-month="todayDt"
              :first-month="firstDt"
              :enableSecondCalendar="true"
            />
          </div>

          <!-- <input class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height" type="date" v-model="form.date" @change="getDateRecipeData" /> -->
        </div>
        <div
          class="relative focus:outline-none lg:w-48 sm:w-1/2 w-full px-3 xl:mt-0 mb-4 lg:mb-0"
        >
          <label for="" class="font-bold text-black-800 uppercase text-sm"
            >Site/Group</label
          >
          <select
            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height select_menu_height"
            v-model="form.site"
            @change="getOffering($event)"
          >
            <option value="">Choose Site/Group</option>
            <optgroup label="Site">
              <option type="site" v-for="site in sites" :value="site.id">
                {{ site.name }}
              </option>
            </optgroup>

            <optgroup label="Groups">
              <option type="group" v-for="site in MenuCreationGroup" :value="site.id">
                {{ site.name }}
              </option>
            </optgroup>
          </select>

          <div
            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white bottom-0 right-3 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none select_menu_height"
          >
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>

        <div
          class="relative focus:outline-none lg:w-48 sm:w-1/2 w-full px-3 xl:mt-0 mb-4 lg:mb-0"
        >
          <label for="" class="font-bold text-black-800 uppercase text-sm"
            >offering</label
          >
          <select
            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
            v-model="form.offer"
            @change="getDateRecipeData"
          >
            <option value="">Choose Offerings</option>
            <option v-for="offer in offerings" :value="offer.id">
              {{ offer.name }}
            </option>
          </select>

          <div
            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white bottom-0 right-3 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none select_menu_height"
          >
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>
        <a href="javascript:void(0)" @click="resetSeatch" class="flex items-center"
          ><img :src="$page.props.asset_url + '/images/clear-filter.png'"
        /></a>

        <button
          v-if="searchResults.length > 1"
          class="button-color w-40 text-white font-bold py-1.5 rounded px-1.5 md:mt-0 mt-4 ml-4"
        >
          <a
            href="javascript:void(0)"
            @click="openFprModal('all')"
          >
            Download All</a
          >
        </button>
      </div>
    </div>

    <TableIndexLayout>
      <div class="-my-2 mb-0">
        <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full pb-0">
          <div class="shadow mb-10 overflow-auto">
            <table class="min-w-full">
              <thead class="header-bg-color">
                <tr>
                  <th
                    scope="col"
                    class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative"
                  >
                    Date
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider"
                  >
                    Site/Group
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider"
                  >
                    Offering
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider"
                  ></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!getDateRecipe" class="bg-white">
                  <td
                    class="px-6 py-4 whitespace-nowrap text-base text-color text-center"
                    colspan="7"
                  >
                    Please select date, site/group, offering
                  </td>
                </tr>

                <tr
                  v-if="getDateRecipe && form.day_id == '' && form.sites.length == 0"
                  class="bg-white"
                >
                  <td
                    class="px-6 py-4 whitespace-nowrap text-base text-color text-center"
                    colspan="7"
                  >
                    No Record Found
                  </td>
                </tr>

                <!-- Odd row -->
                <!-- Sites -->
                <tr
                  class="bg-white"
                  v-if="getDateRecipe && form.day_id != ''"
                  v-for="sresult in searchResults"
                >
                  <td class="text px-6 py-4">
                    <b>{{ convertDate(sresult.date) }}</b>
                  </td>

                  <td class="px-6 py-4">{{ showSiteName() }}</td>
                  <td class="px-6 py-4">{{ showOfferName() }}</td>

                  <td
                    class="px-6 py-4 whitespace-nowrap font-bold underline id-color text-2xl"
                  >
                    <a
                      href="javascript:void(0)"
                      @click="openFprModal('single', sresult)"
                      ><i class="fa fa-external-link" aria-hidden="true"></i
                    ></a>
                  </td>
                </tr>
                <tr v-for="gsite in form.sites" class="bg-white">
                  <td class="text px-6 py-4">
                    <b>{{ convertDate(gsite.date) }}</b>
                  </td>

                  <td class="px-6 py-4">{{ gsite.site_name }}</td>
                  <td class="px-6 py-4">{{ gsite.name }}</td>

                  <td
                    class="px-6 py-4 whitespace-nowrap font-bold underline id-color text-2xl"
                  >
                    <a
                      href="javascript:void(0)"
                      @click="openFprModal('single', gsite)"
                      ><i class="fa fa-external-link" aria-hidden="true"></i
                    ></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </TableIndexLayout>

    <jet-dialog-modal :show="showFprModal" @close="showFprModal = false">
      <template #title>
        <div class="font-bold text-gray-800">
          Select FPR Report Option
        </div>
      </template>

      <template #content>
        <div class="py-4 text-center">
          <p class="text-gray-700 font-semibold mb-6 text-base">
            Which FPR report would you like to download?
          </p>
          <div class="flex flex-wrap justify-center items-center gap-4">
            <button
              type="button"
              @click="downloadFprReport(false)"
              class="btn-fpr-green text-white font-bold py-2.5 px-6 rounded shadow hover:opacity-90 focus:outline-none"
              style="background-color: #39b54a; color: #ffffff;"
            >
              Download FPR
            </button>
            <button
              type="button"
              @click="downloadFprReport(true)"
              class="btn-fpr-blue text-white font-bold py-2.5 px-6 rounded shadow hover:opacity-90 focus:outline-none"
              style="background-color: #219fd5; color: #ffffff;"
            >
              Download simple FPR
            </button>
          </div>
        </div>
      </template>

      <template #footer>
        <button
          type="button"
          class="bg-gray-300 text-gray-800 font-bold py-1.5 px-4 rounded hover:bg-gray-400 focus:outline-none"
          @click="showFprModal = false"
        >
          Cancel
        </button>
      </template>
    </jet-dialog-modal>
  </default-layout>
</template>
<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import Paginate from "@/Pages/Partials/Paginate";
import Option from "../MenuCycle/Option.vue";
// import DateRangePicker from 'daterange-picker-vue3';
// import 'daterange-picker-vue3/dist/daterange-picker-vue3.css'
import moment from "moment";
import DatePicker from "../../components/DatePicker.vue";
import { Dropdown } from "flowbite";
import JetDialogModal from "@/Jetstream/DialogModal";

export default {
  props: ["sites", "MenuCreationGroup"],
  components: {
    DefaultLayout,
    BreadcrumLayout,
    PageTitleLayout,
    TableFilterLayout,
    TableIndexLayout,
    Paginate,
    DatePicker,
    JetDialogModal,
  },
  data() {
    return {
      showFprModal: false,
      fprModalType: "",
      selectedFprItem: null,
      show: {
        calendar: false,
      },
      todayDt: moment(),
      // firstDt: moment().subtract(8, "M"),
      // selectedDate: [moment().subtract(7, "days").startOf("day"), moment().endOf("day")],
      selectedDate: [moment().subtract(7, "days").startOf("day"), moment().endOf("day")],
      disabledFromTo: {
        from: moment("2022-07-01"),
        to: moment("2022-07-21"),
      },

      recipes: [],
      searchResults: [],
      offerings: [],
      options: {},
      exportRecipe: [],
      exportRecipeSearced: [],
      exportAssembly: [],
      recipeStudentCount: [],
      recipeCurrentStudentCount: [],
      searchByName: "",
      siteName: [],
      is_data_show: false,
      date: {
        startDate: null,
        endDate: null,
      },
      form: {
        date: {
          startDate: null,
          endDate: null,
        },
        site: "",
        offer: "",
        type: "",
        day_id: [],
        sites: [],
      },
    };
  },
  computed: {
    getDateRecipe: function () {
      if (
        this.form.date != "" &&
        this.form.site != "" &&
        (this.form.offer != "" || this.form.type == "group")
      ) {
        // this.getDateRecipeData();
        return true;
      } else {
        this.recipes = [];
        return false;
      }
    },
  },
  methods: {
    showCalendar() {
      this.show.calendar = !this.show.calendar;
      if (!this.show.calendar) {
        // selectedDate
        console.log("selectedDate", this.selectedDate[0].format('YYYY/MM/DD'));
        this.changeDate(true);
      }
      // console.log("showCalendar", this.show.calendar);
    },

    addZero(v) {
      if (v < 10) {
        v = `0${v}`;
      }
      return v;
    },

    convertDate(date) {
      return date.split("-").reverse().join("-");
    },

    changeDate(isRender) {
      if(this.selectedDate[0])
      {
        this.form.date.startDate = this.selectedDate[0].format('YYYY/MM/DD');
        this.form.date.endDate = this.selectedDate[1].format('YYYY/MM/DD');
        if(isRender)
        {
          this.getDateRecipeData();
        }

      }
      // let $this = this;
      // setTimeout(() => {
      //   console.log("this.selectedDate", $this.selectedDate, this.selectedDate);
      //   this.form.date.startDate =
      //     this.selectedDate[0].getFullYear() +
      //     "/" +
      //     this.addZero(this.selectedDate[0].getMonth() + 1) +
      //     "/" +
      //     this.addZero(this.selectedDate[0].getDate());
      //   this.form.date.endDate =
      //     this.selectedDate[1].getFullYear() +
      //     "/" +
      //     this.addZero(this.selectedDate[1].getMonth() + 1) +
      //     "/" +
      //     this.addZero(this.selectedDate[1].getDate());

      //   console.log("changeDate form", this.form.date);

      //   this.getDateRecipeData();
      // }, 3000);
    },
    updateDatePicker(value) {
      console.log("updating datepicker value", value);
      // this.datepicker = value;
    },

    showCount(sc) {
      if (isNaN(sc)) {
        return "N/A";
      } else if (sc >= 1) {
        return sc;
      } else if (sc === 0) {
        return 0;
      } else {
        return "N/A";
      }
    },

    resetSeatch() {
      this.form = {
        date: {
          startDate: null,
          endDate: null,
        },
        site: "",
        offer: "",
        type: "",
        day_id: "",
        sites: [],
      };
      this.date = {
        startDate: null,
        endDate: null,
      };
      this.recipes = [];
      this.searchResults = [];
      this.offerings = [];
      this.options = {};
      this.exportRecipe = [];
      this.exportRecipeSearced = [];
      this.exportAssembly = [];
      this.recipeStudentCount = [];
      this.searchByName = "";
    },

    showSiteName() {
      if (this.form.type == "group") {
        return this.MenuCreationGroup.find((e) => e.id == this.form.site).name;
      }
      if (this.form.type == "site") {
        return this.sites.find((e) => e.id == this.form.site).name;
      }
    },

    showOfferName() {
      if (this.form.type == "group") {
        return "-";
      }
      if (this.form.type == "site") {
        return this.offerings.find((e) => e.id == this.form.offer).name;
      }
    },

    getDateRecipeData() {
      console.log("getDateRecipeData", this.form);
      this.changeDate(false);
      if (
        this.form.date.startDate && this.form.date.startDate != "" &&
        this.form.site != "" &&
        (this.form.offer != "" || this.form.type == "group")
      ) {
        let $this = this;
        $this.form.sites = [];
        axios
          .get(this.route("get-food-production-report-data", this.form))
          .then((response) => {
            $this.searchResults = [];
            $this.form.day_id = [];
            console.log("response.data", response.data);
            if (response.data.status) {
              if ($this.form.type == "group") {
                console.log("response.data.data", response.data.data);
                $this.form.sites = response.data.data;
                $this.form.sites.forEach((element) =>
                  $this.searchResults.push({ id: element.day_id, date: element.date })
                );
              } else {
                $this.searchResults = response.data.data;
                $this.searchResults.forEach((element) =>
                  $this.form.day_id.push(element.id)
                );
                console.log("form.day_id", $this.form.day_id);
                // $this.form.day_id = response.data.data;
              }
            } else {
              $this.form.day_id = [];
            }
          })
          .catch((error) => console.error(error));
      }
    },

    getOffering(event) {
      this.form.day_id = [];
      var options = event.target.options;
      console.log("options", options);
      var type = "";
      if (options.selectedIndex > -1) {
        type = options[options.selectedIndex].getAttribute("type");
        console.log("type ", type);
      }
      this.form.type = type;
      console.log("this.form", this.form);

      if (this.form.type == "group") {
        this.getDateRecipeData();
        this.offerings = [];
      } else {
        let sid = this.form.site;
        let site = this.sites.find((o) => o.id === sid);
        if (site) {
          this.offerings = site.offerings;
        } else {
          this.offerings = [];
        }
        this.form.offer = "";
      }
    },
    openFprModal(type, item = null) {
      this.fprModalType = type;
      if (type === 'single' && item) {
        this.selectedFprItem = {
          id: item.id || item.day_id,
          date: item.date,
          site_id: item.site_id || this.form.site,
        };
      } else {
        this.selectedFprItem = null;
      }
      this.showFprModal = true;
    },
    downloadFprReport(isSimple = false) {
      if (this.fprModalType === 'all') {
        this.downloadAllFpr(isSimple);
      } else if (this.fprModalType === 'single') {
        this.downloadSingleFpr(isSimple);
      }
    },
    downloadSingleFpr(isSimple = false) {
      if (!this.selectedFprItem) return;
      let url = '/download-fpr/' + this.selectedFprItem.id + '?curent_date=' + this.selectedFprItem.date + '&site_id=' + this.selectedFprItem.site_id;
      if (isSimple) {
        url += '&simple_fpr=true';
      }
      window.open(url, '_blank');
      this.showFprModal = false;
    },
    downloadAllFpr(isSimple = false) {
      console.log("this.form", this.form);
      this.hideShowLoader('show');
      let url = this.route("download-fpr-all") + '?data=' + encodeURIComponent(JSON.stringify(this.searchResults)) + '&site_id=' + this.form.site + '&offer=' + this.form.offer;
      if (isSimple) {
        url += '&simple_fpr=true';
      }
      axios
        .get(url)
        .then((response) => {
          console.log("response.data", response.data);
          this.hideShowLoader('hide');
          this.$toast.success('Your report is being prepared. We’ll email you a download link when it’s ready.');
        })
        .catch((error) => {
          this.hideShowLoader('hide');
          console.error(error);
        });
      this.showFprModal = false;
    },
    hideShowLoader(types){
        if(types == 'show'){
            document.getElementById('full_loader').style.display = 'flex';
        } else {
            document.getElementById('full_loader').style.display = 'none';
        }
    },
  },
};
</script>
<style>
.id_arrow .fa-sort-desc:before {
  content: "\f0dd";
  position: absolute;
  top: 17px;
  left: 43px;
  padding-left: 7px;
  color: #219fd5;
}
select.select_menu_height {
    height: 2.3rem !important;
}
.select_menu_height {
    height: 2.3rem !important;
}
.select_menu_height i.fa.fa-sort-desc {
    position: relative;
    top: -4px;
}
.id_arrow .fa-sort-asc:before {
  content: "\f0de";
  color: #219fd5;
  padding-left: 7px;
  position: absolute;
  top: 17px;
  left: 43px;
}

.max-height-screen {
  max-height: calc(100vh - 380px);
}
.trim_text {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

.tooltip {
  display: inline-block;
  position: relative;
  text-align: left;
}
.tooltip .top {
  width: 250px;
  top: 50%;
  left: 100%;
  margin-left: 20px;
  transform: translate(0, -50%);
  padding: 5px 10px;
  color: #444444;
  background-color: #eeeeee;
  font-weight: normal;
  font-size: 14px;
  border-radius: 5px;
  position: absolute;
  z-index: 99999999;
  box-sizing: border-box;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
  display: none;
  white-space: normal;
}
.tooltip:hover .top {
  display: block;
}
.tooltip .top i {
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -12px;
  width: 12px;
  height: 24px;
  overflow: hidden;
}
.tooltip .top i::after {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  left: 0;
  top: 50%;
  transform: translate(50%, -50%) rotate(-45deg);
  background-color: #eeeeee;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}
.cart-color {
  color: #f7a53a;
}
.recipe_name_list {
  display: none;
}
.onhover:hover .recipe_name_list {
  display: block;
}
table.min-w-full tr:last-child .recipe_name_list {
  top: auto;
  bottom: 32px;
}
.vue-daterange-picker {
  width: 100%;
  display: block !important;
}
.vue-daterange-picker .form-control.reportrange-text {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow);
  border-radius: 0.5rem;
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}
@media screen and (min-width: 768px) {
  .daterangepicker.show-ranges.show-weeknumbers,
  .daterangepicker.show-ranges {
    min-width: 683px !important;
  }
}
.btn-fpr-green {
  background-color: #39b54a !important;
  color: #ffffff !important;
}
.btn-fpr-green:hover {
  background-color: #2e963d !important;
}
.btn-fpr-blue {
  background-color: #219fd5 !important;
  color: #ffffff !important;
}
.btn-fpr-blue:hover {
  background-color: #1b86b5 !important;
}
</style>
